import { createFormatters } from 'app/infrastructure/data/date';

export enum substanceCodetableIds {
  uomSets = 398,
  hierarchy = 341,
  category = 351
}

export const unitOfMeasureTypeId = 334;

export const unitOfMeasureExcludeId = 3699;

export const userGroupCodetableId = 19;

export const defaultUomConversionFactor = 1;

export const duplicateTranslationSuffixNumber = 2;

export const duplicateSuffix = (locale: string) => createFormatters(locale).formatNumber(duplicateTranslationSuffixNumber, {});

export const maxIconLength = 80;
